import { UserFacingError } from './errors'

export class PropertyNotFoundError extends UserFacingError {
  constructor() {
    super('Property not found')
    this.name = 'PropertyNotFoundError'
  }
}

export class ZoneNotFoundError extends UserFacingError {
  constructor() {
    super('Zone not found')
    this.name = 'ZoneNotFoundError'
  }
}

export class BlindNotFoundError extends UserFacingError {
  constructor() {
    super('Blind not found')
    this.name = 'BlindNotFoundError'
  }
}

export class StandNotFoundError extends UserFacingError {
  constructor() {
    super('Stand not found')
    this.name = 'StandNotFoundError'
  }
}

export class BlindNameConflictError extends UserFacingError {
  constructor() {
    super('A blind with this name already exists on this property')
    this.name = 'BlindNameConflictError'
  }
}

export class MapEntityPhotoNotFoundError extends UserFacingError {
  constructor() {
    super('Photo not found')
    this.name = 'MapEntityPhotoNotFoundError'
  }
}

export class MapFolderNotFoundError extends UserFacingError {
  constructor() {
    super('Folder not found')
    this.name = 'MapFolderNotFoundError'
  }
}

export class MapFolderNameConflictError extends UserFacingError {
  constructor() {
    super('A folder with this name already exists')
    this.name = 'MapFolderNameConflictError'
  }
}

export class ProAccessRequiredError extends UserFacingError {
  constructor() {
    super('BlindBook Pro is required to manage folders')
    this.name = 'ProAccessRequiredError'
  }
}

export class UnauthorizedLocationMutationError extends UserFacingError {
  constructor() {
    super("You don't have permission for this action")
    this.name = 'UnauthorizedLocationMutationError'
  }
}

export class PropertyHasHuntHistoryError extends UserFacingError {
  constructor() {
    super('Cannot delete property with hunt history')
    this.name = 'PropertyHasHuntHistoryError'
  }
}

export class ZoneHasAssociatedBlindsError extends UserFacingError {
  constructor() {
    super('Cannot delete zone with associated blinds')
    this.name = 'ZoneHasAssociatedBlindsError'
  }
}
